var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-container",
    [
      _c(
        "v-form",
        {
          ref: "form",
          staticClass: "ml-2 mr-2 pt-6",
          attrs: { "lazy-validation": "" },
          on: {
            submit: function ($event) {
              $event.preventDefault()
              return _vm.submit.apply(null, arguments)
            },
          },
          model: {
            value: _vm.valid,
            callback: function ($$v) {
              _vm.valid = $$v
            },
            expression: "valid",
          },
        },
        [
          _c(
            "v-row",
            { staticClass: "pt-2 pb-0" },
            [
              _c("v-col", { staticClass: "text-center pb-0" }, [
                _c("p", { staticClass: "text-justify" }, [
                  _vm._v(
                    " Enquanto conferimos o seu endereço, entenda como funciona nossas faturas e selecione a forma de pagamento de sua preferência. "
                  ),
                ]),
                _c("p", { staticClass: "text-justify" }, [
                  _vm._v(
                    " Lembrando que a Juntos não cobra por adesão, anuidade e nem mensalidade. "
                  ),
                ]),
                _c("p", { staticClass: "text-h6 mb-0 text-center" }, [
                  _vm._v("Escolha a forma de pagamento:"),
                ]),
              ]),
            ],
            1
          ),
          _c(
            "v-row",
            { staticClass: "pt-0 pb-4" },
            [
              _c(
                "v-col",
                { attrs: { cols: "4", sm: "4", md: "4", align: "center" } },
                [
                  _c(
                    "v-btn",
                    {
                      attrs: {
                        small: "",
                        rounded: "",
                        color: "primary",
                        dark: "",
                        outlined: _vm.payment_type !== "boleto",
                        block: "",
                      },
                      on: {
                        click: function ($event) {
                          $event.preventDefault()
                          return _vm.setPaymentType("boleto")
                        },
                      },
                    },
                    [
                      _vm.payment_type === "boleto"
                        ? _c(
                            "v-icon",
                            { attrs: { color: "white", left: "" } },
                            [_vm._v("mdi-check")]
                          )
                        : _vm._e(),
                      _vm._v(" Boleto "),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "v-col",
                { attrs: { cols: "4", sm: "4", md: "4", align: "center" } },
                [
                  _c(
                    "v-btn",
                    {
                      attrs: {
                        small: "",
                        rounded: "",
                        color: "primary",
                        dark: "",
                        outlined: _vm.payment_type !== "credit_card",
                        block: "",
                      },
                      on: {
                        click: function ($event) {
                          $event.preventDefault()
                          return _vm.setPaymentType("credit_card")
                        },
                      },
                    },
                    [
                      _vm.payment_type === "credit_card"
                        ? _c(
                            "v-icon",
                            { attrs: { color: "white", left: "" } },
                            [_vm._v("mdi-check")]
                          )
                        : _vm._e(),
                      _vm._v(" Cartão"),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "v-col",
                { attrs: { cols: "4", sm: "4", md: "4", align: "center" } },
                [
                  _c(
                    "v-btn",
                    {
                      attrs: {
                        small: "",
                        rounded: "",
                        color: "primary",
                        dark: "",
                        outlined: _vm.payment_type !== "pix",
                        block: "",
                      },
                      on: {
                        click: function ($event) {
                          $event.preventDefault()
                          return _vm.setPaymentType("pix")
                        },
                      },
                    },
                    [
                      _vm.payment_type === "pix"
                        ? _c(
                            "v-icon",
                            { attrs: { color: "white", left: "" } },
                            [_vm._v("mdi-check")]
                          )
                        : _vm._e(),
                      _vm._v(" Pix "),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm.payment_type === "credit_card"
            ? _c(
                "v-img",
                {
                  staticStyle: { "border-radius": "30px" },
                  attrs: {
                    src: require("@/assets/cards/images/" +
                      _vm.currentCardBackground +
                      ".jpeg"),
                  },
                },
                [
                  _c(
                    "v-card",
                    {
                      staticClass: "white--text pa-5 ma-2",
                      attrs: { color: "transparent elevation-0" },
                    },
                    [
                      _c(
                        "v-row",
                        {
                          staticClass: "pa-2 pt-2 pb-2",
                          attrs: { justify: "space-between" },
                        },
                        [
                          _c(
                            "v-col",
                            { attrs: { cols: "8" } },
                            [
                              _c("v-img", {
                                attrs: {
                                  src: require("@/assets/cards/images/chip.png"),
                                  width: "48px",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "v-col",
                            { staticClass: "pa-2", attrs: { cols: "4" } },
                            [
                              _c("v-img", {
                                staticStyle: {
                                  "max-height": "70px!important",
                                  width: "auto!important",
                                },
                                attrs: {
                                  src: require("@/assets/cards/images/" +
                                    _vm.card_type +
                                    ".png"),
                                },
                              }),
                            ],
                            1
                          ),
                          _c("v-col", { attrs: { cols: "12" } }, [
                            _c("h3", [
                              _vm._v(
                                _vm._s(
                                  _vm.maskCardNumber(_vm.cardNumber) ||
                                    "0000 0000 0000 0000"
                                )
                              ),
                            ]),
                          ]),
                          _c("v-col", { attrs: { cols: "9" } }, [
                            _c("h4", [
                              _vm._v(_vm._s(_vm.cardName || "Nikola Tesla")),
                            ]),
                          ]),
                          _c("v-col", { attrs: { cols: "3" } }, [
                            _vm._v(_vm._s(_vm.expire || "09/25")),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm.payment_type === "credit_card"
            ? _c(
                "v-row",
                [
                  _c(
                    "v-col",
                    { staticClass: "pt-6 pb-0" },
                    [
                      _c("v-text-field", {
                        attrs: {
                          label: "Nome como está no cartão",
                          required: "",
                          rules: _vm.nameRules,
                          filled: "",
                          rounded: "",
                          autofocus: "",
                          dense: "",
                        },
                        model: {
                          value: _vm.cardName,
                          callback: function ($$v) {
                            _vm.cardName = $$v
                          },
                          expression: "cardName",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    { staticClass: "pt-0 pb-0", attrs: { cols: "12" } },
                    [
                      _c("v-text-field", {
                        directives: [
                          {
                            name: "mask",
                            rawName: "v-mask",
                            value: _vm.cardMask,
                            expression: "cardMask",
                          },
                        ],
                        attrs: {
                          type: "tel",
                          rules: _vm.numberRules,
                          label: "Numero do Cartão",
                          placeholder: "####-####-####-####",
                          maxlength: _vm.cardNumberMaxLength,
                          "return-masked-value": "",
                          required: "",
                          filled: "",
                          rounded: "",
                          dense: "",
                        },
                        model: {
                          value: _vm.cardNumber,
                          callback: function ($$v) {
                            _vm.cardNumber = $$v
                          },
                          expression: "cardNumber",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    { staticClass: "pt-0 pb-0", attrs: { cols: "6" } },
                    [
                      _c("v-text-field", {
                        directives: [
                          {
                            name: "mask",
                            rawName: "v-mask",
                            value: "##/##",
                            expression: "'##/##'",
                          },
                        ],
                        attrs: {
                          rules: _vm.expireRules,
                          label: "Data de Validade",
                          name: "expire",
                          type: "tel",
                          placeholder: "##/##",
                          "return-masked-value": "",
                          required: "",
                          filled: "",
                          rounded: "",
                          dense: "",
                        },
                        model: {
                          value: _vm.expire,
                          callback: function ($$v) {
                            _vm.expire = $$v
                          },
                          expression: "expire",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    { staticClass: "pt-0 pb-2", attrs: { cols: "6" } },
                    [
                      _c("v-text-field", {
                        directives: [
                          {
                            name: "mask",
                            rawName: "v-mask",
                            value: _vm.cvvMask,
                            expression: "cvvMask",
                          },
                        ],
                        attrs: {
                          type: "password",
                          rules: _vm.cvvRules,
                          label: "Código de Verificação",
                          name: "code",
                          placeholder: "###",
                          required: "",
                          filled: "",
                          rounded: "",
                          dense: "",
                        },
                        model: {
                          value: _vm.cvv,
                          callback: function ($$v) {
                            _vm.cvv = $$v
                          },
                          expression: "cvv",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm.payment_type === "credit_card"
            ? _c(
                "div",
                { staticClass: "body-2 pa-3 pt-2" },
                [
                  _c(
                    "v-alert",
                    {
                      attrs: {
                        type: "info",
                        color: "primary",
                        dense: "",
                        outlined: "",
                      },
                    },
                    [
                      _c("p", { staticClass: "font-weight-bold" }, [
                        _vm._v("Você receberá duas contas separadas"),
                      ]),
                      _vm._v(
                        " No cartão você pagará pela geração da energia limpa para a Juntos. Você continuará pagando a conta da sua concessionária. Mas apenas os custos mínimos e/ou excedentes de consumo, encargos e impostos. "
                      ),
                    ]
                  ),
                  _c(
                    "v-alert",
                    {
                      attrs: {
                        type: "info",
                        color: "primary",
                        dense: "",
                        outlined: "",
                      },
                    },
                    [
                      _vm._v(
                        " Para segurança, nós iremos realizar uma pré autorização no valor de R$1,23 no seu cartão. Isso é apenas para verificação e o valor não será cobrado da sua fatura. "
                      ),
                    ]
                  ),
                  _c(
                    "v-alert",
                    {
                      attrs: {
                        type: "info",
                        color: "primary",
                        dense: "",
                        outlined: "",
                      },
                    },
                    [
                      _vm._v(
                        " Qualquer cobrança no seu cartão de crédito será realiza somente após a efetivação do cadastro e abatimento dos créditos de energia em sua conta de luz. "
                      ),
                    ]
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm.payment_type === "boleto"
            ? _c(
                "v-card",
                { attrs: { flat: "" } },
                [
                  _vm.lead.utility === "cemig"
                    ? _c(
                        "v-card-text",
                        [
                          _c(
                            "v-alert",
                            {
                              attrs: {
                                type: "info",
                                color: "primary",
                                dense: "",
                                outlined: "",
                              },
                            },
                            [
                              _c("p", { staticClass: "font-weight-bold" }, [
                                _vm._v("Pague tudo em um único boleto"),
                              ]),
                              _vm._v(
                                " Enviamos mensalmente uma fatura unificada detalhando o consumo da energia gerada pelas nossas fazendas e as taxas de transmissão da CEMIG e impostos. "
                              ),
                            ]
                          ),
                        ],
                        1
                      )
                    : _c(
                        "v-card-text",
                        [
                          _c(
                            "v-alert",
                            {
                              attrs: {
                                type: "info",
                                color: "primary",
                                dense: "",
                                outlined: "",
                              },
                            },
                            [
                              _c("p", { staticClass: "font-weight-bold" }, [
                                _vm._v("Duas contas separadas"),
                              ]),
                              _vm._v(
                                " Você continuará pagando a conta da sua concessionária, mas apenas os custos mínimos e/ou excedentes de consumo, encargos e impostos. É importante destacar que a cobrança será realizada somente após o primeiro ciclo de uso da energia da Juntos. "
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                ],
                1
              )
            : _vm._e(),
          _vm.payment_type === "pix"
            ? _c(
                "v-card",
                { attrs: { flat: "" } },
                [
                  _c(
                    "v-card-text",
                    [
                      _c(
                        "v-alert",
                        {
                          attrs: {
                            type: "info",
                            color: "primary",
                            dense: "",
                            outlined: "",
                          },
                        },
                        [
                          _c("p", { staticClass: "font-weight-bold" }, [
                            _vm._v("Você receberá duas contas separadas"),
                          ]),
                          _vm._v(
                            " No PIX você pagará pela geração da energia limpa para a Juntos. Você continuará pagando a conta da sua concessionária. Mas apenas os custos mínimos e/ou excedentes de consumo, encargos e impostos. "
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm.error_message
            ? _c(
                "div",
                {
                  staticClass:
                    "body-2 red--text font-weight-bold text-center pb-3",
                },
                [_vm._v(" " + _vm._s(_vm.error_message) + " ")]
              )
            : _vm._e(),
          _vm.payment_type === "credit_card"
            ? _c(
                "v-btn",
                {
                  staticClass: "mr-4 text-none",
                  attrs: {
                    color: "secondary",
                    type: "submit",
                    disabled: !_vm.valid || _vm.loading,
                    loading: _vm.loading,
                    rounded: "",
                    block: "",
                    large: "",
                  },
                },
                [
                  _vm._v(
                    " " +
                      _vm._s(
                        _vm.user && _vm.user.signedcontract_at
                          ? "Cadastrar Cartão"
                          : "Continuar"
                      ) +
                      " "
                  ),
                ]
              )
            : _c(
                "v-btn",
                {
                  staticClass: "mr-4 text-none",
                  attrs: {
                    color: "secondary",
                    disabled: !_vm.valid || _vm.loading,
                    loading: _vm.loading,
                    rounded: "",
                    block: "",
                    large: "",
                  },
                  on: {
                    click: function ($event) {
                      return _vm.save(true)
                    },
                  },
                },
                [
                  _vm._v(
                    " " +
                      _vm._s(
                        _vm.user && _vm.user.signedcontract_at
                          ? "Finalizar"
                          : "Continuar"
                      ) +
                      " "
                  ),
                ]
              ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }